import { render, staticRenderFns } from "./quotation-status-change.vue?vue&type=template&id=6f9ababb"
import script from "./quotation-status-change.vue?vue&type=script&lang=js"
export * from "./quotation-status-change.vue?vue&type=script&lang=js"
import style0 from "./quotation-status-change.vue?vue&type=style&index=0&id=6f9ababb&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports